//import axios from "axios";

export function useErrorsData() {

  function getErrorMessage(error) {
    // 1. Дефолтный текст, если сервер промолчал
    let errorText = "Произошла неизвестная ошибка при обработке запроса";

    if (!error) return errorText;

    // 2. Проверка на падение сети (сервер выключен)
    if (error.code === "ERR_NETWORK") {
      return "Отсутствует соединение с сервером. Пожалуйста, проверьте сеть или повторите попытку позже!";
    }

    // 3. Вытаскиваем точечное сообщение от нашего Spring-сервиса
    if (error.response && error.response.data) {
      const data = error.response.data;

      // Проверяем классические поля ответов Spring Boot (message или error)
      if (data.message) {
        errorText = data.message;
      } else if (data.error) {
        errorText = data.error;
      } else if (typeof data == "string") {
        // Если бэкенд вернул просто сырую строку вместо JSON-объекта
        errorText = data;
      }
    } else if (error.message) {
      // Фолбек на дефолтный текст ошибки Axios
      errorText = error.message;
    }

    return errorText;
  }

  return {
    getErrorMessage,
  };
}
